package com.anjuros.website.templates.template2.modules

import com.anjuros.website.templates.template2.util.ResKey


enum class Template2Review(
    val title: ResKey,
    val review: ResKey,
    val author: String,
) {

    Review6(
        title = ResKey.TEMPLATE2_REVIEW6_TITLE,
        review = ResKey.TEMPLATE2_REVIEW6,
        author = "Sarah T."
    ),
    Review2(
        title = ResKey.TEMPLATE2_REVIEW2_TITLE,
        review = ResKey.TEMPLATE2_REVIEW2,
        author = "James W."
    ),
    Review3(
        title = ResKey.TEMPLATE2_REVIEW3_TITLE,
        review = ResKey.TEMPLATE2_REVIEW3,
        author = "Emma H."
    ),
    Review4(
        title = ResKey.TEMPLATE2_REVIEW4_TITLE,
        review = ResKey.TEMPLATE2_REVIEW4,
        author = "Oliver B."
    ),
    Review5(
        title = ResKey.TEMPLATE2_REVIEW5_TITLE,
        review = ResKey.TEMPLATE2_REVIEW5,
        author = "Charlotte M."
    ),
    Review1(
        title = ResKey.TEMPLATE2_REVIEW1_TITLE,
        review = ResKey.TEMPLATE2_REVIEW1,
        author = "Thomas C."
    ),
    Review7(
        title = ResKey.TEMPLATE2_REVIEW7_TITLE,
        review = ResKey.TEMPLATE2_REVIEW7,
        author = "Lucy P."
    ),
    Review8(
        title = ResKey.TEMPLATE2_REVIEW8_TITLE,
        review = ResKey.TEMPLATE2_REVIEW8,
        author = "Daniel R."
    ),
    Review9(
        title = ResKey.TEMPLATE2_REVIEW9_TITLE,
        review = ResKey.TEMPLATE2_REVIEW9,
        author = "Sophie G."
    ),
    Review10(
        title = ResKey.TEMPLATE2_REVIEW10_TITLE,
        review = ResKey.TEMPLATE2_REVIEW10,
        author = "William F."
    ),

}